import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase URL e Anon Key são obrigatórios');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Types para as tabelas
export interface CampanhaCupom {
  id: string;
  nome: string;
  descricao: string | null;
  periodo_inicio: string;
  periodo_fim: string;
  banner_url: string | null;
  regulamento_url: string | null;
  status: 'ativa' | 'pausada' | 'encerrada';
  mes_referencia: string;
  ano: number;
  created_at: string;
  updated_at: string;
}

export interface CupomCliente {
  id: string;
  cliente_id: number;
  numero_cupom: string;
  origem: 'compra' | 'indicacao';
  venda_id: number | null;
  indicacao_id: number | null;
  valor_compra: number | null;
  quantidade_cupons: number;
  data_geracao: string;
  data_validade: string;
  status: 'ativo' | 'inativo' | 'cancelado' | 'usado';
  sorteio_id: string | null;
  cancelado_em: string | null;
  motivo_cancelamento: string | null;
  created_at: string;
  updated_at: string;
  revendedora_venda: number | null;
}

export interface SorteioCupom {
  id: string;
  campanha_id: string;
  tipo: 'semanal' | 'super_live';
  data_sorteio: string;
  titulo: string;
  descricao: string | null;
  premio_descricao: string | null;
  status: 'pendente' | 'realizado' | 'cancelado';
  total_cupons_participantes: number;
  total_participantes_unicos: number;
  realizado_em: string | null;
  created_at: string;
  updated_at: string;
}

export interface GanhadorSorteio {
  id: string;
  sorteio_id: string;
  cupom_id: string;
  cliente_id: number;
  cliente_nome: string;
  cliente_codigo: string | null;
  cliente_cidade: string | null;
  cliente_estado: string | null;
  cliente_instagram: string | null;
  revendedora_id: number;
  revendedora_nome: string;
  revendedora_codigo: string | null;
  premio_descricao: string | null;
  validado: boolean;
  presente_na_live: boolean;
  data_validacao: string | null;
  observacoes: string | null;
  created_at: string;
  updated_at: string;
}
